<div class="legal-container">
    <div class="legal-content">
        <h1 class="title">Aviso Legal</h1>
        <hr class="separator-line">
        <p class="subtitle">Última actualización: febrero 2025</p>

        <h2>1. Identificación del titular</h2>
        <p>
            En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de
            la Información y Comercio Electrónico (LSSICE), se informa al usuario de los datos del titular de este
            sitio web:
        </p>
        <ul>
            <li><strong>Denominación:</strong> Ayuntamiento de La Oliva</li>
            <li><strong>Domicilio:</strong> C. Emilio Castellot, 2, 35640 La Oliva, Las Palmas</li>
            <li><strong>Teléfono:</strong> +34 928 86 19 04</li>
            <li><strong>Correo electrónico:</strong> <a href="mailto:informacion@laoliva.es">
                    informacion&#64;laoliva.es</a></li>
        </ul>

        <h2>2. Objeto</h2>
        <p>
            El presente sitio web tiene como finalidad la promoción del municipio de La Oliva como Destino Turístico
            Inteligente, ofreciendo información sobre sus recursos turísticos, culturales y naturales, además de
            herramientas interactivas como encuestas de satisfacción y mapas de puntos de interés.
        </p>

        <h2>3. Condiciones de uso</h2>
        <p>
            El acceso y uso de este sitio web atribuye la condición de usuario e implica la aceptación de todas las
            condiciones incluidas en este Aviso Legal. El usuario se compromete a hacer un uso adecuado del sitio
            web y de sus contenidos, de conformidad con la legislación vigente y el presente Aviso Legal.
        </p>

        <h2>4. Propiedad intelectual e industrial</h2>
        <p>
            Los contenidos de este sitio web, incluyendo textos, fotografías, gráficos, imágenes, iconos, tecnología,
            software, enlaces y demás contenidos audiovisuales, así como su diseño gráfico y códigos fuente, son
            propiedad intelectual del titular, sin que puedan entenderse cedidos al usuario ninguno de los derechos
            de explotación sobre los mismos más allá de lo estrictamente necesario para el correcto uso del sitio web.
        </p>
        <p>
            Este proyecto ha sido cofinanciado por la Unión Europea a través de los Fondos Europeos de Desarrollo
            Regional (FEDER), en el marco de la convocatoria de Destinos Turísticos Inteligentes.
        </p>

        <h2>5. Exclusión de responsabilidad</h2>
        <p>
            El titular no se hace responsable de los daños y perjuicios que pudieran derivarse del uso de este sitio
            web, incluyendo, sin limitación, errores u omisiones en los contenidos, falta de disponibilidad del sitio
            web o la transmisión de virus o programas maliciosos a través de los contenidos.
        </p>

        <h2>6. Modificaciones</h2>
        <p>
            El titular se reserva el derecho de modificar, en cualquier momento y sin previo aviso, la presentación
            y configuración del sitio web, así como las condiciones de uso. El usuario se compromete a revisar
            periódicamente el presente Aviso Legal.
        </p>

        <h2>7. Legislación aplicable y jurisdicción</h2>
        <p>
            Para la resolución de cualquier controversia que pudiera surgir en relación con el acceso o uso de este
            sitio web, serán competentes los Juzgados y Tribunales de Las Palmas de Gran Canaria, con renuncia
            expresa del usuario a cualquier otro fuero que pudiera corresponderle.
        </p>
    </div>
</div>